import { REDUX_ACTIONS } from '../../shared/config/constants';
import { parseError } from '../../utils/fetchErrorParser';
import fetch from '../../api/fetch';
import { convertFiltersToV5Format } from '../../utils/filterFormatConversionToV5';
import { enqueueSnackbar } from './snackbar';
import store from '../store';

export const listCheckIns = (payload) => (dispatch) => {
  const { checkIns } = store.getState();

  dispatch({
    type: REDUX_ACTIONS.CHECKINS_LIST_LOADING,
  });
  const body = {
    input: {
      searchValue: payload?.search ? payload?.search : checkIns?.searchKey || '',
      startDate: payload?.selectedStartDateTime ? payload?.selectedStartDateTime : checkIns?.startDate || '',
      endDate: payload?.selectedEndDateTime ? payload?.selectedEndDateTime : checkIns?.endDate || '',
      filters: convertFiltersToV5Format(checkIns?.filters?.items) || [],
      page: payload?.page || 1,
      linkOperator: checkIns?.filters?.logicOperator || '',
      sort: checkIns?.sort || null,
      division: payload?.division ? payload?.division : checkIns?.division || '',
      isCurrentPage: payload?.isCurrentPage,
      limit: payload?.limit
    }
  };
  return fetch
    .post('checkins/fetch', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.CHECKINS_LIST_SUCCESS,
        payload: {
          data: data.data,
          paginatedElements: data.count,
          totalCount: data.count
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.CHECKINS_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const syncCheckIns = () => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.CHECKINS_SYNC_LOADING,
    payload: {
      message: 'Please wait...',
    },
  });

  return fetch
    .post('enverus/syncWells')
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then(async (data) => {
      await dispatch(listCheckIns());
      dispatch({
        type: REDUX_ACTIONS.CHECKINS_SYNC_IDLE,
        payload: {
          message: data.message,
        },
      });
    })
    .catch(async (error) => {
      dispatch(
        enqueueSnackbar(
          error.message || 'Error syncing wells',
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.CHECKINS_SYNC_ERROR,
        payload: {
          message: error.message || 'Error syncing wells',
        },
      });
    });
};

export const fetchCheckInsDetail = (body) => (dispatch) => {
  return fetch
    .post('enverus/wells/fetch-one', { input: body })
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.CHECKINS_DETAILS_SUCCESS,
        payload: data,
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.CHECKINS_DETAILS_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};

export const getCheckInsEmailKPIs =
  (startDate = null, endDate = null) =>
    (dispatch) => {
      dispatch({
        type: REDUX_ACTIONS.CHECK_INS_EMAIL_KPIS_LOADING,
      });

      const body = {
        input: {
          startDate, endDate
        }
      };

      const path = 'checkins/email-KPIs';
      return fetch
        .post(path, body)
        .then((resp) => {
          if (!resp.ok) {
            return Promise.reject(resp);
          }
          return resp.json();
        })
        .then((data) => {
          const chartData = data.map((item, index) => {
            return { ...item, y: item.count, label: item.UserEmail, _id: index, division: item.division || 'Other' };
          });
          dispatch({
            type: REDUX_ACTIONS.CHECK_INS_EMAIL_KPIS_SUCCESS,
            payload: chartData
          });
        })
        .catch(async (error) => {
          const errorMessage = await parseError(error);

          dispatch(
            enqueueSnackbar(
              errorMessage,
              'error',
              new Date().getTime() + Math.random()
            )
          );
          dispatch({
            type: REDUX_ACTIONS.CHECK_INS_EMAIL_KPIS_ERROR,
            payload: { ...error, message: errorMessage },
          });
        });
    };

export const getCheckInsDivisionKPIs =
    (startDate = null, endDate = null) =>
      (dispatch) => {
        dispatch({
          type: REDUX_ACTIONS.CHECK_INS_DIVISION_KPIS_LOADING,
        });

        const body = {
          input: {
            startDate, endDate
          }
        };

        const path = 'checkins/division-KPIs';
        return fetch
          .post(path, body)
          .then((resp) => {
            if (!resp.ok) {
              return Promise.reject(resp);
            }
            return resp.json();
          })
          .then((data) => {
            const chartData = data.map((item, index) => {
              return { ...item, y: item.count, _id: index, division: item.division };
            });
            dispatch({
              type: REDUX_ACTIONS.CHECK_INS_DIVISION_KPIS_SUCCESS,
              payload: chartData
            });
          })
          .catch(async (error) => {
            const errorMessage = await parseError(error);

            dispatch(
              enqueueSnackbar(
                errorMessage,
                'error',
                new Date().getTime() + Math.random()
              )
            );
            dispatch({
              type: REDUX_ACTIONS.CHECK_INS_DIVISION_KPIS_ERROR,
              payload: { ...error, message: errorMessage },
            });
          });
      };

export const exportCheckIns = () => (dispatch) => {
  const { checkIns } = store.getState();

  const body = {
    input: {
      searchValue: checkIns?.searchKey || '',
      startDate: checkIns?.startDate || '',
      endDate: checkIns?.endDate || '',
      filters: checkIns?.filters?.items || [],
      logicOperator: checkIns?.filters?.logicOperator || '',
      sort: checkIns?.sort || null,
      division: checkIns?.division || '',
      limit: '',
      isCurrentPage: false
    }
  };

  const path = 'checkins/downloadCSV';
  return fetch
    .post(path, body)
    .then((resp) => {
      if (!resp.ok) {
        return Promise.reject(resp);
      }
      return resp.json();
    })
    .then((data) => {
      // Convert JSON data to CSV format
      const blob = new Blob([data], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'POT_CheckIns.csv';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);

      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.CHECKINS_LIST_ERROR,
        payload: { ...error, message: errorMessage },
      });
    });
};

export const listPayPictures = (_id) => (dispatch) => {
  dispatch({
    type: REDUX_ACTIONS.CHECKINS_PAY_PICTURES_LIST_LOADING,
  });
  const body = {
    query: {
      _id,
    }
  };
  return fetch
    .postWithUTC('checkins/payPictures', body)
    .then((result) => {
      if (!result.ok) {
        return Promise.reject(result);
      }
      return result.json();
    })
    .then((data) => {
      dispatch({
        type: REDUX_ACTIONS.CHECKINS_PAY_PICTURES_LIST_SUCCESS,
        payload: {
          data: data.data,
        },
      });
    })
    .catch(async (error) => {
      const errorMessage = await parseError(error);
      dispatch(
        enqueueSnackbar(
          errorMessage,
          'error',
          new Date().getTime() + Math.random()
        )
      );
      dispatch({
        type: REDUX_ACTIONS.CHECKINS_PAY_PICTURES_LIST_ERROR,
        payload: { ...error, message: 'Error' },
      });
    });
};
